<ngx-editor [editor]="editor" />
<ngx-editor-floating-menu [editor]="editor" />
